import LegalShell from "@/components/LegalShell";
import usePriceLabel from "@/hooks/usePriceLabel";

export default function Terms() {
    const priceLabel = usePriceLabel();
    return (
        <LegalShell title="Terms & Conditions" testId="page-terms">
            <p className="text-sm text-aq-muted">
                <strong>Last updated:</strong> 28 June 2026
            </p>

            <p>
                These terms govern your use of the AcademiQ assessment and report service provided
                by TheCounselCo / PRISM EDUTIVES LLP ("we", "us"). By purchasing or using the
                service, you (the parent/guardian) agree to these terms.
            </p>

            <h2>1. The service</h2>
            <p>
                For a one-time fee of {priceLabel}, your child takes an online assessment of
                approximately 30 minutes, and you receive a personalised PDF report covering their
                Multiple Intelligences, Quotients, strengths, growth areas, and suggested career
                and stream directions. The report is personally reviewed by Hemangi Shah before
                delivery.
            </p>

            <h2>2. Delivery</h2>
            <p>
                The report is delivered to the WhatsApp number and email address you provide,
                within 24–48 hours of your child completing the assessment. It is your
                responsibility to provide accurate contact details. We are not responsible for
                non-delivery caused by incorrect details supplied by you.
            </p>

            <h2>3. Eligibility and consent</h2>
            <p>
                The assessment is intended for students in Grades 7–12. By purchasing, you confirm
                you are the parent or legal guardian of the student and consent to your child
                taking the assessment.
            </p>

            <h2>4. Honest responses</h2>
            <p>
                The accuracy and usefulness of the report depend on the student answering
                genuinely. The report reflects the responses given.
            </p>

            <h2>5. Nature of the service (please read)</h2>
            <ul>
                <li>
                    AcademiQ is a guidance and profiling tool for educational purposes only. It is
                    <strong> NOT</strong> a clinical, psychological, psychiatric or medical
                    assessment, and does <strong>not</strong> diagnose, identify or treat any
                    condition, including learning disabilities or mental-health conditions. If
                    you have concerns of that nature, please consult a qualified professional.
                </li>
                <li>
                    The report offers directions to explore — it is not a guarantee or prediction
                    of any academic, career, admission or financial outcome. Decisions about your
                    child's streams, subjects and career remain yours, to be made using your own
                    judgement alongside other guidance.
                </li>
                <li>
                    Career, course and examination information in the report is general, accurate
                    to the best of our knowledge as of the report date. Such information changes
                    over time; please verify specific exam patterns, courses and admission
                    requirements independently before acting on them.
                </li>
            </ul>

            <h2>6. Payment</h2>
            <p>
                Payment is processed by Razorpay. The fee is {priceLabel} (inclusive of applicable taxes).
            </p>

            <h2>7. Refunds</h2>
            <p>
                Refunds are governed by our <a href="/refund">Refund & Cancellation Policy</a>.
            </p>

            <h2>8. Intellectual property</h2>
            <p>
                The assessment, the report format, and all related content (including the book{" "}
                <i>Beyond School – Be Future Ready</i>) are the intellectual property of
                TheCounselCo / Hemangi Shah and may not be copied, resold or redistributed without
                permission. The report is provided for your family's personal use.
            </p>

            <h2>9. Limitation of liability</h2>
            <p>
                To the extent permitted by law, our total liability in connection with the service
                is limited to the amount you paid ({priceLabel}). We are not liable for decisions made
                based on the report, as set out in Section 5.
            </p>

            <h2>10. Contact</h2>
            <p>
                <a href="mailto:thecounselco@gmail.com">thecounselco@gmail.com</a>
            </p>

            <h2>11. Governing law</h2>
            <p>
                These terms are governed by the laws of India, with jurisdiction in Mumbai,
                Maharashtra.
            </p>
        </LegalShell>
    );
}
